module.exports = __webpack_public_path__ + "static/gallery-11-a398da467d29b278859a1136d5e944c3.jpg";